import { PAYMENTS_MODULE } from 'utils/roles/permissions';
import {
  PAYMENTS_LIST_PATH,
  PAYMENTS_DETAIL_PATH,
  MULTI_CONTRACT_PAYMENTS_DETAIL_PATH,
} from 'utils/roles/paths';
import { PAYMENTS_CHARGES_LIST } from '../../../utils/roles/permissions';

export function paymentsAuth(permissions) {
  const allowedModules = [];

  const paymentModule = permissions.filter((permission) =>
    permission.includes('PAYMENT')
  );

  if (paymentModule.length > 0) {
    allowedModules.push(PAYMENTS_MODULE);
  }

  return allowedModules;
}

export function paymentsPathsAuth(permissions) {
  const allowedPaths = [
    PAYMENTS_DETAIL_PATH,
    MULTI_CONTRACT_PAYMENTS_DETAIL_PATH,
  ];


    allowedPaths.push(PAYMENTS_LIST_PATH);



  return allowedPaths;
}
